import React, { Fragment } from 'react'
import Link from 'next/link'
import Button from '@/components/common/Button'
import Player from '../common/Player'
import { MediaPlayer } from '../speaker/MediaPlayer'

const GetinContactSections = ({ data, isLoading }) => {
  return (
    <>
      <div className="relative mb-20 md:hidden">
        <div className="mb-2 md:divide-y md:divide-blue-900">
          <h1 className="mb-4 text-2xl font-extrabold leading-6 text-white uppercase sm:text-2xl w-full tagline-font">
            {data?.impactful?.title}.
          </h1>
        </div>
        {isLoading ? (
          <div className="flex flex-wrap shadow md:hidden">
            <div className="flex flex-col flex-wrap p-4 animate-pulse">
              <div className=" bg-custom-gray-80 w-full late-200 h-[250px] w-screen"></div>
            </div>
          </div>
        ) : (
          // <div className="w-full h-[250px] mb-6 md:hidden z-[0]">
          //   <Player
          //     className="w-full h-full"
          //     videoUrl={data?.impactful?.video?.videoUrl}
          //     isPlaying={false}
          //     playInline={true}
          //     volumeUpWhenPlayed={true}
          //   />
          // </div>
          <React.Fragment />
        )}
        <h2 className="mt-6 leading-5 lg:w-full lg:text-base md:text-sm">
          When you partner with UTA Speakers, you'll have access to not only the best speakers but
          also our expert team of event professionals. As a full-service agency, we ensure your
          event runs smoothly and successfully, from speaker selection to standing ovation. Our goal
          is to help you create an unforgettable experience that leaves a lasting impact on your
          audience. Let's plan your event together.
        </h2>
        <br></br>
        <div className="flex justify-center md:justify-start">
          <Link href="/contact" legacyBehavior>
            <a className="py-4 text-xs border px-11 tagline-font button-hover">Get In Contact</a>
          </Link>
        </div>
      </div>
      <div className="relative hidden mb-20 md:flex md:mb-24">
        <div className="left-sec1">
          <div className="impactful-width">
            <h1 className="text-white uppercase uta-font-size tagline-font">
              {data?.impactful?.title}.
            </h1>
          </div>
          {isLoading ? (
            <div className="flex flex-wrap shadow md:hidden">
              <div className="flex flex-col flex-wrap p-4 animate-pulse">
                <div className=" bg-custom-gray-80 w-full late-200 h-[250px] w-screen"></div>
              </div>
            </div>
          ) : (
              <React.Fragment />
            // <div className="w-full h-[250px] mb-6 md:hidden z-[0]">
              /* <Player
                className="w-full h-full"
                videoUrl={data?.impactful?.video?.videoUrl}
                isPlaying={false}
                playInline={true}
                key={data?.impactful?.video?.videoUrl}
                width="100%"
                height="250px"
                volumeUpWhenPlayed={true}
              /> */
            //   <MediaPlayer
            //     className="videoplayer w-full h-full"
            //     autoPlay={false}
            //     videoUrl={data?.impactful?.video?.videoUrl}
            //   />
            // </div>
            
          )}
          <h2 className="mt-6 leading-5 lg:w-full lg:text-xl md:text-sm">
            When you partner with UTA Speakers, you'll have access to not only the best speakers but
            also our expert team of event professionals. As a full-service agency, we ensure your
            event runs smoothly and successfully, from speaker selection to standing ovation. Our
            goal is to help you create an unforgettable experience that leaves a lasting impact on
            your audience. Let's plan your event together.
          </h2>
          <br></br>
          <div className="flex justify-center md:justify-start">
            <Link href="/contact" legacyBehavior>
              <a>
                <Button
                  className="py-4 text-xs border px-11 tagline-font button-hover"
                  label="Get In Contact"
                ></Button>
              </a>
            </Link>
          </div>
        </div>
        <div className="right-sec hidden">
          <div className="hidden home-video-sec md:block">
            {isLoading ? (
              <div className="flex flex-wrap shadow">
                <div className="flex flex-col flex-wrap p-4 animate-pulse">
                  <div className=" bg-custom-gray-80 w-full late-200 w-[40vw] h-[60vh]"></div>
                </div>
              </div>
            ) : (
              // <Player
              //   className="w-full h-full"
              //   videoUrl={data?.impactful?.video?.videoUrl}
              //   isPlaying={false}
              //   playInline={true}
              //   volumeUpWhenPlayed={true}
              // />
              <MediaPlayer
                className="videoplayer w-full h-full"
                autoPlay={false}
                videoUrl={data?.impactful?.video?.videoUrl}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default GetinContactSections
